import axios from "axios";

const API_URL = "/api/students"; // Adjust this URL to your backend API endpoint

export const getStudents = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching students:", error);
    throw error;
  }
};

export const addStudent = async (studentData) => {
  try {
    const response = await axios.post(API_URL, studentData);
    return response.data;
  } catch (error) {
    console.error("Error adding student:", error);
    throw error;
  }
};

export const editStudent = async (studentId, studentData) => {
  console.log("editStudent", studentData);
  try {
    const response = await axios.put(`${API_URL}/${studentId}`, studentData);
    return response.data;
  } catch (error) {
    console.error("Error editing student:", error);
    throw error;
  }
};

export const uploadStudentPhoto = async (studentId, file) => {
  const formData = new FormData();
  formData.append("files", file);
  const response = await axios.post(`${API_URL}/${studentId}/photo`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteStudent = async (studentId) => {
  try {
    const response = await axios.delete(`${API_URL}/${studentId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting student:", error);
    throw error;
  }
};
